import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
button.text-button {
    min-width: 145px;
    min-height: 28px;
    border: 1px solid #ffffff;
    border-radius: 3px;
    font-family: 'Nimbus Sans', sans-serif;
    line-height: 22px;
    text-decoration: none;
    color: #ffffff;
    background: transparent;
    padding: 8px 20px;
}
button.text-button:hover {
    color: #000000;
    background: #ffffff;
}
`;

export default styles;


// WEBPACK FOOTER //
// ./src/components/LeadGenButton/LeadGenButton.css